import { IEReservationIntervalDateGroupDto } from "modules/appointment/Dtos/IEReservationIntervalDateGroupDto";

import { DateObject } from "utils/DateObject";

import { createIntervalDateGroup } from "./intervalDateGroup";

export const createIntervalList = (
  date: string
): IEReservationIntervalDateGroupDto[] => {
  const [month, year] = date.split("-");
  const receivedDate = DateObject(year + "-" + month + "-01");
  return createDates(receivedDate.getMonth() + 1).map((date) =>
    createIntervalDateGroup(date)
  );
};

const createDates = (month: number) => {
  return [
    `2021-${month}-01`,
    `2021-${month}-03`,
    `2021-${month}-05`,
    `2021-${month}-08`,
    `2021-${month}-09`,
    `2021-${month}-11`,
    `2021-${month}-12`,
    `2021-${month}-15`,
    `2021-${month}-16`,
    `2021-${month}-17`,
    `2021-${month}-20`,
    `2021-${month}-21`,
    `2021-${month}-23`,
    `2021-${month}-24`,
    `2021-${month}-26`,
    `2021-${month}-27`,
  ];
};
